"use client";

import { type Choix, choisir, useChoix } from "@/lib/theme";

const CHOIX: { valeur: Choix; label: string; icone: React.ReactNode }[] = [
  {
    valeur: "light",
    label: "Thème clair",
    icone: (
      <>
        <circle cx="8" cy="8" r="3" />
        <path d="M8 1.5v1.5M8 13v1.5M1.5 8H3M13 8h1.5M3.4 3.4l1 1M11.6 11.6l1 1M3.4 12.6l1-1M11.6 4.4l1-1" />
      </>
    ),
  },
  {
    valeur: "dark",
    label: "Thème sombre",
    icone: <path d="M13.5 9.5A5.5 5.5 0 1 1 6.5 2.5a4.5 4.5 0 0 0 7 7Z" />,
  },
  {
    valeur: "auto",
    label: "Thème du système",
    icone: (
      <>
        <circle cx="8" cy="8" r="5.5" />
        <path d="M8 2.5v11A5.5 5.5 0 0 0 8 2.5Z" fill="currentColor" />
      </>
    ),
  },
];

export default function ThemeToggle() {
  const courant = useChoix();
  return (
    <div className="theme-choix" role="group" aria-label="Thème">
      {CHOIX.map((c) => (
        <button
          key={c.valeur}
          type="button"
          title={c.label}
          aria-label={c.label}
          aria-pressed={courant === c.valeur}
          onClick={() => choisir(c.valeur)}
        >
          <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" aria-hidden>
            {c.icone}
          </svg>
        </button>
      ))}
    </div>
  );
}
